import { render } from "./DetailsPhotoPage.vue?vue&type=template&id=090beb86"
import script from "./DetailsPhotoPage.vue?vue&type=script&lang=js"
export * from "./DetailsPhotoPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__